import * as PersonalInfo from "./personalInfo";
import * as ProgressInfo from "./progressInfo";
import * as Accounting from "./accounting";
import * as Reports from "./reports";
import * as Attachments from "./attachments";
import * as ChainOfCustody from "./chainOfCustody";

export default function Modules(dbName) {
    Accounting.initDB(dbName);
    PersonalInfo.initDB(dbName);
    ProgressInfo.initDB(dbName);
    Attachments.initDB(dbName);
    Reports.initDB(dbName);
    ChainOfCustody.initDB(dbName);

    return {
        PersonalInfo,
        ProgressInfo,
        Accounting,
        Reports,
        Attachments,
        ChainOfCustody,
    };
}